import $ from "jquery";
import moment from "moment";

const TIME_FORMAT = 'HH:mm';
const IS_RUNNING_HTML = ``; // Uncomment and update if needed
// const IS_RUNNING_HTML = `
// <div class="row text-truncate mt-1">
//   <div class="col-12 d-flex align-items-center">
//     <span class="badge bg-success">läuft derzeit</span>
//   </div>
// </div>`;

const SPINNER = `
<div id="list_loader" class="row mt-3">
  <div class="col-12 justify-content-center text-center">
    <div class="spinner-border text-primary text-center" role="status"></div>
  </div>
</div>`;

const flagTrue = (value) => value === true || value === 'true' || value === 1 || value === '1';

const statusBadges = (event) => {
  const badges = [];

  if (flagTrue(event.cancelled)) {
    badges.push('ABGESAGT');
  }
  if (flagTrue(event.sold_out)) {
    badges.push('AUSVERKAUFT');
  }

  if (!badges.length) {
    return '';
  }

  const badgeHtml = badges.map((label) => (
    `<span class="badge bg-warning text-dark fw-bold text-uppercase">${label}</span>`
  )).join('');

  return `
<div class="row mb-2">
  <div class="col-12 d-flex flex-wrap gap-2">
    ${badgeHtml}
  </div>
</div>`;
};


const NEU_BADGE = `<div class="neubadge badge bg-primary d-flex align-items-center p-absolute neubadge-event-img-pad" data-neubadge="true">NEU</div>`;
const ADS_BADGE = `<div class="badge bg-common-black d-flex align-items-center p-absolute neubadge-event-img-pad">ANZEIGE</div>`;

function eventTimes(event) {
  if (event.start_time_whole_day) {
    return 'Ganztägig';
  }

  const fin = moment.utc(event.finish_time).local();
  const sta = moment.utc(event.start_time).local();

  if (fin < sta || (fin > sta && fin.hour() === 0)) {
    return sta.format(TIME_FORMAT);
  }

  if (sta.format(TIME_FORMAT) === fin.format(TIME_FORMAT)) {
    return `${sta.format("HH:mm")} Uhr`;
  }

  return `${sta.format(TIME_FORMAT)} - ${fin.format(TIME_FORMAT)} Uhr`;
}

$(document).ready(() => {
  const eventListNode = $('#turbo-event-list');
  const eventAdsEnabled = eventListNode.length ? eventListNode.data('event-ads-enabled') !== false : true;

  window.scrollLoad = true;
  window.referer = 1;

  $(window).scroll(async () => {
    if ($('#event_loaded_list').length === 1) {
      if (window.scrollLoad && window.location.href.includes("events") && $(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
        $("#event_loaded_list").append(SPINNER);
        window.scrollLoad = false;
        window.referer += 1;

        const suggestions = await getEventList(window.referer);
        const timeNow = moment().local();
        const a_day_ago_in_ms = Date.now() - 86400000;

        suggestions.data.data.forEach(event => {
          const start_time = event.start_time_whole_day ? "Ganztägig" : moment.utc(event.start_time).local().format("HH:mm");
          const end_time = start_time === "Ganztägig" ? "" : moment.utc(event.finish_time).local().format("HH:mm");
          const event_date = event.start_time ? moment.utc(event.start_time).local() : timeNow;
          const event_date_finish = event.finish_time ? moment.utc(event.finish_time).local() : timeNow;
          const is_single_day = event_date.format('MM.DD.YYYY') === event_date_finish.format('MM.DD.YYYY');
          const event_date_actual = is_single_day ? event_date : (event_date > timeNow ? event_date : timeNow);
          const event_display_date = is_single_day ? moment(event_date).locale("de").format("dddd, DD.MM.YYYY") : `${moment(event_date).locale("de").format("dddd, DD.MM.YYYY")} -<br>${moment(event_date_finish).locale("de").format("dddd, DD.MM.YYYY")}`;
          const bg_image = event.images_data ? `<div class="img-blur-wrap"><div class="img-blur" style="height: 200px; background-size: cover; background-image: url('${event.images_data[0].orig}');"></div></div>` : `<div class="img-blur-wrap"><div class="img-blur-bg event_no_img" style="height: 200px;"></div><div class="img-blur event_no_img" style="height: 200px; background: #efefef;"></div></div>`;

          const isCancelled = flagTrue(event.cancelled);
          const status_div        = statusBadges({ cancelled: isCancelled, sold_out: flagTrue(event.sold_out) });
          const is_running = isCancelled ? false : moment.utc(timeNow).local().isBetween(event_date, event_date_finish);
          const times_line = eventTimes(event);

          let address_line = event.address.street;
          if (event.address.place) {
            address_line = `${address_line}, ${event.address.place}`;
          }

          let debug_div = '';
          if (window.location.href.startsWith('http://localhost')) {
            debug_div = `<div style="font-size: 8pt; color: red;"><span>${event.start_time} - ${event.finish_time}</span></div>`;
          } else if (window.location.href.startsWith('https://meinort-test.lab1')) {
            debug_div = `<div style="display:none;"><span>${event.start_time} - ${event.finish_time}</span></div>`;
          }

          // if this event has been created within the last 24hours, it's
          // supposed to be new --> show the "NEU" - badge
          let neu_badge_div = '';
          let ads_badge_div = '';
          const isNew = new Date(event["publication_date"]).getTime() > a_day_ago_in_ms;
          if (isNew) {
            neu_badge_div = NEU_BADGE;
          }

          let is_running_span     = is_running ? IS_RUNNING_HTML : '';
          let german_distance_str = (Math.round(event["distance"] * 10) / 10).
            toString().toString().replace(/\./g, ',');

          if (event["b_advert"] && eventAdsEnabled) {
            ads_badge_div = isNew
              ? `<div class="ms-5 badge bg-common-black d-flex align-items-center p-absolute neubadge-event-img-pad">ANZEIGE</div>`
              : ADS_BADGE;
          }
          let img_div = "";
          if (event["images_data"]) {
            img_div = `
              <div class="br-hr-10 p-relative">
                <img class="event-img br-hr-10" alt="${event["title"]}" src="${event["images_data"][0]["orig"]}">
                ${neu_badge_div}
                ${ads_badge_div}
              </div>`;

          } else {
            img_div = `
              <div class="img-blur-wrap br-hr-10">
                <div class="img-blur-bg event_no_img" style="height: 200px;"></div>
                <div class="img-blur event_no_img" style="height: 200px;"></div>
                ${neu_badge_div}
                ${ads_badge_div}
              </div>`;
          }

          const html = `
<li class="row mb-3 mb-md-1" data-event-id="${event.lw_id}">
  <a class="link-dark text-decoration-none pe-lg-0" href="/events/${event.lw_id}">
    <div class="box br-hr-10">
      <div class="box-middle p-0" style="min-height: 200px">
        <div class="row">
          <div class="col-md-4 p-lg-0 m-lg-0">
            ${img_div}
            <div class="box event-date position-absolute br-10 text-center shadow date-on-sm bg-primary border-0">
              <div class="box-middle p-2">
                <h6>${event_date_actual.locale("de").format('MMM').toUpperCase()}</h6>
                <h2 class="fw-bold text-common-black">${event_date_actual.format('DD')}</h2>
                <h6>${event_date_actual.format('YYYY')}</h6>
              </div>
            </div>
          </div>
          <div class="col-md-8 pt-3 pe-3 ps-5 pb-3 pb-lg-0 pb-md-0">
            ${status_div}
            <div class="row">
              <div class="col-12">
                <h2 class="h6 fw-bold pe-3 text-truncate-2">${event.title}</h2>
              </div>
            </div>

            <ul class="ps-0 row text-default-gray">
              <li class="col-12 d-flex align-items-center common-text-black">
                <div class="icon-place"></div>
                <span class="text-truncate ps-2">${address_line}</span>
              <li class="col-12 d-flex common-text-black">
                <div class="icon-event mt-1"></div>
                <span class="ps-2">${event_display_date}</span>
              </li>
              <li class="col-12 d-flex align-items-center common-text-black">
                <div class="icon-time-clock-circle"></div>
                <span class="ps-2">${times_line}</span>
              </li>
              <li class="col-12 d-flex align-items-center text-truncate mt-1 common-text-black">
                ${is_running_span}
                <span class="badge bg-common-black">~${german_distance_str} km</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </a>
</li>`;
          $("#event_loaded_list").append(html);
        });

        if (suggestions.data.data.length < 1) {
          window.scrollLoad = false;
          if (!$("#event_loaded_list").html().includes("Alle Ergebnisse gesehen")) {
            $("#event_loaded_list").append(`<p class="fs-small text-black-50 text-center mt-3">Alle Ergebnisse gesehen</p>`);
          }
        } else {
          window.scrollLoad = true;
        }
        $("#list_loader").remove();
      }
    }
  });
});

const FILTER_FIELDS = ['search', 'category', 'event_date', 'radius'];

// The events page has two filter forms (desktop sidebar + mobile modal).
// Keep them in sync on submit so the infinite scroll below always reads the
// values the current list was filtered with, and restart the pagination.
document.addEventListener('turbo:submit-start', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="event_date"]')) {
    return;
  }

  const formData = new FormData(form);
  document.querySelectorAll('form').forEach((other) => {
    if (other === form || !other.querySelector('[name="event_date"]')) {
      return;
    }
    FILTER_FIELDS.forEach((name) => {
      const field = other.querySelector(`[name="${name}"]`);
      if (field) {
        field.value = formData.get(name) || '';
      }
    });
  });

  window.referer = 1;
  window.scrollLoad = true;
});

// The Geschäftsanzeigen-slider sits inside the event list, which filtering
// replaces via turbo_stream — no turbo:load fires there, so slick has to be
// re-initialized right after the stream has rendered.
document.addEventListener('turbo:before-stream-render', (event) => {
  const originalRender = event.detail.render;
  event.detail.render = async (streamElement) => {
    await originalRender(streamElement);
    if (typeof window.initAdsSlider === 'function') {
      window.initAdsSlider();
    }
  };
});

document.addEventListener("turbo:before-cache", () => {
  $('select').each(function () {
    const el = $(this);
    const selected = el.val();
    el.find('option').prop('selected', false);
    if (selected) {
      el.find(`option[value='${selected}']`).prop('selected', true);
    }
  });
});

async function getEventList(page_count) {
  const query = new URLSearchParams({
    page: page_count,
    radius: $('#event-radius').val() || '',
    search: $('#event_index_input_search').val() || '',
    category: $('#event_category').val() || '',
    event_date: $('.event-datepicker').val() || '',
  });
  const response = await fetch(`/load-new-events?${query}`, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  return response.json();
}

function getUrlParameter(sParam) {
  const sPageURL = window.location.search.substring(1);
  const sURLVariables = sPageURL.split('&');

  for (const sParameterName of sURLVariables) {
    const [key, value] = sParameterName.split('=');
    if (key === sParam) {
      return value === undefined ? true : decodeURIComponent(value);
    }
  }
  return "";
}

$(document).on('turbo:load', () => {
  $("#add-to-calendar").on("click", function () {
    const ics = require('ics');
    const file_name = $(this).data('title');
    const file_desc = $(this).data('desc').replace(/<[^>]*>?/gm, ' ');
    const duration_ = $(this).data('duration');
    const start_time = new Date($(this).data('start'));
    const end_time = new Date($(this).data('finish'));

    ics.createEvent({
      title: file_name,
      description: file_desc,
      start: [start_time.getFullYear(), start_time.getMonth() + 1, start_time.getDate(), start_time.getHours(), start_time.getMinutes()],
      duration: duration_ ? { hours: 23, minutes: 59 } : '',
      end: !duration_ ? [end_time.getFullYear(), end_time.getMonth() + 1, end_time.getDate(), end_time.getHours(), end_time.getMinutes()] : ''
    }, (error, value) => {
      if (error) {
        console.log(error);
      } else {
        const blob = new Blob([value], { type: 'text/calendar' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, `${file_name}.ics`);
        } else {
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style.display = "none";
          const icsUrl = URL.createObjectURL(blob);
          a.href = icsUrl;
          a.download = `${file_name}.ics`;
          a.click();
          URL.revokeObjectURL(a.href);
          a.remove();
        }
      }
    });
  });

  $("#event_radius_list li").each(function () {
    $(this).on("click", function () {
      Turbo.visit(`/events?radius=${$(this).data('radius')}`, { action: 'replace' });
    });
  });

  $(".close-event-filter").click(() => {
    $("#events-filter-modal").modal("hide");
  });
});
